import React from 'react'
import ProgressBar from './ProgressBar';


function Experience() {
  return (
    <div id="experience">
      <ProgressBar />
    </div>

  )
}

export default Experience